var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-button",
        {
          staticClass: "menu-bg-blue-transparent",
          attrs: { title: "Extents", variant: "outline-dark" },
          on: {
            click: function ($event) {
              return _vm.getExtents()
            },
          },
        },
        [_c("fa", { attrs: { icon: ["fas", "globe"], size: "lg" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "selectExtent",
            size: "md",
            "content-class": "menu-bg-blue-transparent-modal",
            centered: "",
            "hide-header": "",
            "hide-footer": "",
          },
        },
        [
          _c(
            "b-container",
            [
              _c(
                "b-row",
                { attrs: { "align-h": "center", "align-v": "center" } },
                [
                  _c("b-col", { attrs: { cols: "6" } }, [
                    _c("h4", { staticClass: "center" }, [_vm._v("Extents:")]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      attrs: {
                        cols: "6",
                        "align-h": "center",
                        "align-v": "center",
                      },
                    },
                    _vm._l(_vm.extents, function (e) {
                      return _c(
                        "b-row",
                        { key: e.id, attrs: { value: e } },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "mb-2",
                              attrs: { variant: "success" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeExtent(e)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(e.extent_description) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }